import React from "react";

const Close = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 17L17 0.999999M1 1L17 17"
        stroke-linecap="round"
        strokeWidth="3"
      />
    </svg>
  );
};

export default Close;
